import { render, staticRenderFns } from "./ProductServiceFwxs.vue?vue&type=template&id=79bc00e4&scoped=true&"
import script from "./ProductServiceFwxs.vue?vue&type=script&lang=js&"
export * from "./ProductServiceFwxs.vue?vue&type=script&lang=js&"
import style0 from "./ProductServiceFwxs.vue?vue&type=style&index=0&lang=less&"
import style1 from "./ProductServiceFwxs.vue?vue&type=style&index=1&id=79bc00e4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79bc00e4",
  null
  
)

export default component.exports